export const createCertificationStepJudgesRequests = (client) => ({
    listCertificationStepJudges: async (params) => {
        const { data, meta, links } = await client.api.get("certification_step_judges", {
            params: params,
        });
        return { data, meta, links };
    },
    findCertificationStepJudge: async (params) => {
        const { data } = await client.api.get(`certification_step_judges/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    finalizeCertificationAttempt: async (payload) => {
        const { data } = await client.api.request({
            type: "certification_step_judges",
            url: `/certification_step_judges/finalize`,
            body: payload,
            method: "POST",
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map